import { optSelect } from '@/services/outletsdepartStorehouseOpt';
import { message } from 'antd';

export default {
  namespace: 'OutletsDepartStorehouseOpt',
  state: {
    queryPayload: {},
  },
  effects: {
    /**
     * 删除
     *
     * @param {Object} payload - 删除请求的载荷对象
     * @param {Object} effects - Redux sagas 中的 effects 对象
     * @param {Function} effects.call - 调用异步函数的方法
     * @param {Function} effects.put - 发送 action 的方法（当前未使用）
     * @param {Function} [callback] - 删除成功后的回调函数，可选参数
     * @returns {void} 无返回值
     */
    *fetchDelete({ payload, callback }, { call, put }) {
      try {
        // const data = yield call(fetchDelete, payload); // 调用删除请求的异步函数
        // message.success('删除成功'); // 成功时显示成功消息
        // if (callback) {
        //   callback(); // 执行回调函数
        // }
      } catch (error) {
        console.error('删除请求时发生错误:', error); // 打印错误信息
      }
    },
    /**
     * 导出数据
     *
     * @param {Object} payload - 载荷对象
     * @param {Object} effects - Redux sagas 中的 effects 对象
     * @param {Function} effects.call - 调用异步函数的方法
     * @param {Function} [callback] - 导出成功后的回调函数，可选参数
     * @returns {void} 无返回值
     */
    *exportData({ payload, callback }, { call }) {
      try {
        // console.log('Payload:', payload);
        // const data = yield call(selectAndExport, payload);
        // if (callback) {
        //   callback(data.code);
        // }
      } catch (error) {
        console.error('导出数据时发生错误:', error);
      }
    },
    /**
     * 导入数据
     *
     * @param payload 导入数据的载荷
     * @param callback 导入完成后的回调函数
     * @param call 调用selectAndImport函数的函数
     * @returns 导入数据的结果
     */
    *importData({ payload, callback }, { call }) {
      try {
        // const data = yield call(selectAndImport, payload);
        // callback && callback(data);
        // return data; // 返回导入的数据结果
      } catch (error) {
        console.error('导入数据时发生错误:', error);
      }
    },
    // 重置
    *reset({}, { select, put }) {
      yield put({
        type: 'updateData',
        payload: {},
      });
    },
  },
  reducers: {
    updateData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
